import React from "react";
import ReturnOfGoodsFromCustomersGenericSkeleton from "./ReturnOfGoodsFromCustomersGenericSkeleton";

function ReturnOfGoodsFromCustomersDetailSkeleton() {
  return (
    <>
      <ReturnOfGoodsFromCustomersGenericSkeleton />
    </>
  );
}

export default ReturnOfGoodsFromCustomersDetailSkeleton;
